import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';
import { CoreService } from '../services/core.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private activeState = true;

  constructor(
    private authService: AuthService,
    private coreService: CoreService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.activeAccount) {
      this.coreService.checkForUserRoles(state.url);
      return this.activeState;
    }

    // wait for auth
    return this.authService.authenticated$.pipe(
      map(() => {
        this.coreService.checkForUserRoles(state.url);
        return this.activeState;
      })
    );
  }

  // used to set Active state
  public setActiveState(state: boolean): void {
    this.activeState = state;
  }
}
